'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.renderCountdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _renderCountdown = require('./render-countdown');

Object.defineProperty(exports, 'renderCountdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_renderCountdown).default;
  }
});

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateHelpers = require('./date-helpers');

var _dateHelpers2 = _interopRequireDefault(_dateHelpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */


/**
 * A countdowntimer that can be paused.
 * @public
 * @param {Object} props
 *   The properties
 * @param {Boolean} props.isRunning
 *   Defines if the timer is running or paused
 * @param {number} props.timerWarning
 *   Defines when the timer warns you
 * @param {number} props.end
 *   Defines when the timerends
 * @param {renderCountdown} props.render
 *   A function that can be passed to render the timer
 */
var Countdown = function (_Component) {
  _inherits(Countdown, _Component);

  _createClass(Countdown, null, [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        isRunning: _propTypes2.default.bool,
        timerWarning: _propTypes2.default.number,
        end: _propTypes2.default.number.isRequired,
        render: _propTypes2.default.func.isRequired
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        isRunning: false,
        timerWarning: 0
      };
    }

    /**
     * A countdowntimer that can be paused.
     * @public
     * @param {Object} props
     *   The properties
     * @param {Boolean} props.isRunning
     *   Defines if the timer is running or paused
     * @param {number} props.timerWarning
     *   Defines when the timer warns you
     * @param {number} props.end
     *   Defines when the timerends
     * @param {renderCountdown} props.render
     *   A function that can be passed to render the timer
     */

  }]);

  function Countdown(props) {
    _classCallCheck(this, Countdown);

    /**
     * @private
     * @property {number} days
     * @property {number} hours
     * @property {number} minutes
     * @property {number} seconds
     * @property {number} start
     * @property {number} waiting
     * @property {number} waited
     */
    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));

    _this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      start: _this.now.getTime(),
      waiting: _this.props.isRunning ? 0 : _this.now.getTime(),
      waited: 0
    };

    _this.run = _this.run.bind(_this);
    _this.stop = _this.stop.bind(_this);
    return _this;
  }

  /**
   * @private
   */


  _createClass(Countdown, [{
    key: 'run',


    /**
     * @private
     * @param {(Boolean|number)} force
     *   If a `Boolean` use it to force runs.
     */
    value: function run() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var now = this.now;
      var then = this.then;
      var diff = then - now;
      var done = diff <= 0;
      var days = done ? 0 : Math.abs(~~(diff / _dateHelpers2.default.d));
      var hours = done ? 0 : Math.abs(~~(diff / _dateHelpers2.default.h) % 24);
      var minutes = done ? 0 : Math.abs(~~(diff / _dateHelpers2.default.m) % 60);
      var seconds = done ? 0 : Math.abs(~~(diff / _dateHelpers2.default.s) % 60);
      if (!done && this.props.isRunning || !done && force === true) {
        this.setState({
          done: done,
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        });
        window.requestAnimationFrame(this.run);
      } else {
        this.stop();
      }
    }

    /**
     * @private
     */

  }, {
    key: 'stop',
    value: function stop() {
      window.cancelAnimationFrame(this.run);
    }

    /**
     * @private
     */

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var now = this.now.getTime();
      var then = this.state.waited + this.props.end * _dateHelpers2.default.m;
      this.setState({
        start: now,
        days: Math.abs(~~(then / _dateHelpers2.default.d)),
        hours: Math.abs(~~(then / _dateHelpers2.default.h) % 24),
        minutes: Math.abs(~~(then / _dateHelpers2.default.m) % 60),
        seconds: Math.abs(~~(then / _dateHelpers2.default.s) % 60)
      });

      if (this.props.isRunning) {
        this.run();
      } else {
        this.setState({
          waiting: now
        });
      }
    }

    /**
     * @private
     * @param {Object} newProps
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      if (newProps.isRunning && !this.props.isRunning) {
        var waiting = this.state.waiting;

        this.setState(function (prevState) {
          return {
            waited: prevState.waited + (_this2.now.getTime() - waiting)
          };
        });
        this.run(true);
      } else if (!newProps.isRunning && this.props.isRunning) {
        this.setState({
          waiting: this.now.getTime()
        });
        this.stop();
      }
    }

    /**
     * @private
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }

    /**
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          days = _state.days,
          hours = _state.hours,
          minutes = _state.minutes,
          seconds = _state.seconds,
          done = _state.done;

      return this.props.render({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      }, done, this.props.timerWarning);
    }
  }, {
    key: 'now',
    get: function get() {
      return new Date();
    }

    /**
     * @private
     */

  }, {
    key: 'then',
    get: function get() {
      return this.state.start + this.state.waited + this.props.end * _dateHelpers2.default.m;
    }
  }]);

  return Countdown;
}(_react.Component);

/**
 * @typedef renderCountdown
 * @public
 * @param {Object} data
 *   Time data
 * @param {number} data.days
 *   Remaining days
 * @param {number} data.hours
 *   Remaining hours
 * @param {number} data.minutes
 *   Remaining minutes
 * @param {number} data.seconds
 *   Remaining seconds
 * @param {Boolean} isDone
 *   Triggered when the timer is done
 * @param {Boolean} timerWarning
 *   Triggered when the warning limit has been reached
 * @return {ReactElement}
 */


exports.default = Countdown;
//# sourceMappingURL=index.js.map